import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

const Item = styled.li`
  margin-bottom: ${theme('spacing.base')};
`

export default Item
